import { axiosInstance } from '../utils/axios';

import { createSearchPath } from '../components/Search/utils/createSearchPath';

export const getGlobalFacets = extraData =>
  axiosInstance('/search/facets', extraData);

export const getChannelFacets = (
  { orgId, streamId, channelId, searchParams = null },
  extraData,
) =>
  axiosInstance(`/${orgId}/${streamId}/${channelId}/items/search/facets`, {
    ...extraData,
    params: {
      ...extraData?.params,
      searchParams,
      refresh: Math.random(),
    },
  });
export const getSearchingStreamItems = (
  { path, params: { q, count, offset } },
  extraData,
) =>
  axiosInstance(`${createSearchPath(path)}/search`, {
    ...extraData,
    params: {
      ...extraData?.params,
      q,
      count,
      offset,
    },
  });
